import type { I18nLocale } from "@/modules/i18n/types"
import type { ActiveSlugsData } from "@/modules/jobSearchPrefiltered/types"

import { getApiUrl } from "@/modules/api/api"
import { keysToCamelCase } from "@/modules/apiRequests/dataStructure"
import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { GET_ACTIVE_SLUGS_ENDPOINT } from "@/modules/jobSearchPrefiltered/constants"

type RequestParams = { page: `${number}`; page_size: `${number}` }

export async function getActiveSlugs({
  locale,
  hostname,
  params,
}: {
  locale: I18nLocale
  hostname: string
  params?: RequestParams
}): Promise<ActiveSlugsData> {
  return fetcher(
    getApiUrl({ hostname, path: GET_ACTIVE_SLUGS_ENDPOINT }),
    {
      body: JSON.stringify(params || { page: "1", page_size: 1000 }),
      headers: {
        "Accept-Language": locale,
      },
      method: "POST",
    },
    { serviceDomain: "GATEWAY_API" }
  )
    .then(getResultFromResponse<ActiveSlugsData>({ transformResult: keysToCamelCase<ActiveSlugsData> }))
    .catch(handleFetchError(GET_ACTIVE_SLUGS_ENDPOINT, { locale, ...params }))
}
